<template>
  <div>
    <div class="banner" :style="cover">
      <h1 class="banner-title">工具箱</h1>
    </div>
    <v-card class="blog-container blog_container_for_toolbox">
      <div class="tag-checkbox">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedTags"
          @change="handleCheckedTagChange"
        >
          <el-checkbox
            v-for="tag in tagsConfig"
            :label="tag"
            :key="tag"
            border
            size="medium"
            >{{ tag }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <p class="message-tip">
        #分享一些高质量的开源网页项目，可以前往
        <router-link to="/message" style="color: #1976d2">留言板</router-link
        >留下您的建议
      </p>
      <div v-for="(item, index) of toolboxTypes" :key="index">
        <!-- <el-row>
          {{ item.typeCn }}
        </el-row> -->
        <el-row style="display: flex; flex-wrap: wrap; justify-content: center">
          <el-col
            style="width: 270px; margin: 16px 13px"
            v-for="(itemSub, indexSub) in item.toolboxes"
            :key="indexSub"
            :class="isInCheckedTagsClass(itemSub.typeTags)"
          >
            <el-card class="card" shadow="never">
              <div>
                <a @click="jumpUrl(itemSub.link, itemSub.id)" target="_blank">
                  <v-img
                    class="on-hover"
                    width="270"
                    height="150"
                    cover
                    :src="itemSub.coverImageUrl"
                  />
                </a>
              </div>
              <div class="article-wrapper">
                <a @click="jumpUrl(itemSub.link, itemSub.id)" target="_blank">
                  <div class="article-name">
                    <div>
                      {{ itemSub.name }}
                    </div>
                  </div>
                </a>
                <el-divider></el-divider>
                <div class="article-title">
                  <div>
                    {{ itemSub.title }}
                  </div>
                  <div style="font-size: 14px; margin-left: 12px; color: #999">
                    <span>({{ itemSub.clickNum }}人访问)</span>
                    <!-- <i class="mdi mdi-eye" style="margin-left: 4px"></i> -->
                  </div>
                </div>
                <div class="article-tags">
                  <el-tag
                    class="article-tags-tag"
                    v-for="itemTag in itemSub.typeTags"
                    :key="itemTag"
                    >{{ itemTag }}</el-tag
                  >
                </div>
                <div style="margin: 12px 0px; display: flex; flex-wrap: wrap">
                  <el-rate
                    @change="changeRate(itemSub)"
                    style="margin-top: auto"
                    v-model="itemSub.rateNum"
                  ></el-rate>
                  <span style="margin-left: 4px">{{ itemSub.rateNum }}</span>
                  <span style="margin-left: 4px; color: #999"
                    >({{ itemSub.rateCount }}人评分)</span
                  >
                </div>
                <div class="article-info">
                  <!-- 文章标签 -->
                  <el-row style="font-style: italic">
                    <el-col :span="16">项目</el-col>
                    <el-col :span="4">是</el-col>
                    <el-col :span="4">否</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16"
                      >开源服务<a
                        :href="itemSub.sourceLink"
                        style="margin-left: 4px"
                        target="_blank"
                      >
                        <v-icon size="small">mdi mdi-link</v-icon></a
                      ></el-col
                    >
                    <el-col
                      :span="4"
                      v-text="checkIsTag('IS_OPENSOURCE', itemSub.tags)"
                      :class="checkIsTagClass('IS_OPENSOURCE', itemSub.tags)"
                    ></el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsNotTag('IS_OPENSOURCE', itemSub.tags)"
                      :class="checkIsNotTagClass('IS_OPENSOURCE', itemSub.tags)"
                    ></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16">不需代理</el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsTag('IS_NOT_NEED_VPN', itemSub.tags)"
                      :class="checkIsTagClass('IS_NOT_NEED_VPN', itemSub.tags)"
                    ></el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsNotTag('IS_NOT_NEED_VPN', itemSub.tags)"
                      :class="
                        checkIsNotTagClass('IS_NOT_NEED_VPN', itemSub.tags)
                      "
                    ></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16">自部署</el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsTag('IS_SELGBUILD', itemSub.tags)"
                      :class="checkIsTagClass('IS_SELGBUILD', itemSub.tags)"
                    ></el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsNotTag('IS_SELGBUILD', itemSub.tags)"
                      :class="checkIsNotTagClass('IS_SELGBUILD', itemSub.tags)"
                    ></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16">支持中文</el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsTag('IS_SUPPORT_CHINESE', itemSub.tags)"
                      :class="
                        checkIsTagClass('IS_SUPPORT_CHINESE', itemSub.tags)
                      "
                    ></el-col>
                    <el-col
                      :span="4"
                      v-text="checkIsNotTag('IS_SUPPORT_CHINESE', itemSub.tags)"
                      :class="
                        checkIsNotTagClass('IS_SUPPORT_CHINESE', itemSub.tags)
                      "
                    ></el-col>
                  </el-row>
                </div>
                <el-divider></el-divider>
                <!-- 文章内容 -->
                <el-tooltip placement="top">
                  <template slot="content">
                    <p style="max-width: 400px">{{ itemSub.description }}</p>
                  </template>
                  <div class="article-content">
                    {{ itemSub.description }}
                  </div>
                </el-tooltip>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import {
  toolboxList,
  toolboxView,
  toolboxRate,
  toolboxTagsConfig,
} from "../../api";

export default {
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "兮游,seayouth,兮游博客,seayouth博客,chatgpt,AI绘图,AI作品图集,AI语音,游戏模拟器", //变量或字符串
      },
      {
        name: "description",
        content:
          "一个专注于AI技术分享的博客平台,无论您是AI爱好者、学者、开发者，还是对AI应用有兴趣的读者，这里都能为您提供有价值的内容和思考",
      },
    ],
  },
  data: function () {
    return {
      toolboxTypes: [],
      tagsConfig: [],
      checkAll: true,
      isIndeterminate: true,
      checkedTags: [],
    };
  },
  mounted() {
    this.getToolboxTagsConfig();
    this.getToolboxList();
  },
  methods: {
    isInCheckedTagsClass(toolboxTags) {
      for (var i = 0; i < toolboxTags.length; i++) {
        if (this.checkedTags.indexOf(toolboxTags[i]) > -1) {
          return "showClass";
        }
      }
      return "hideClass";
    },
    handleCheckAllChange(val) {
      this.checkedTags = val ? this.tagsConfig : [];
      this.isIndeterminate = false;
    },
    handleCheckedTagChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tagsConfig.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tagsConfig.length;
    },
    jumpUrl(link, id) {
      toolboxView({ id: id })
        .then((res) => {
          window.open(link, "_blank");
        })
        .catch((err) => {});
    },
    checkIsTag(tag, tags) {
      if (tags.includes(tag)) {
        return "✔";
      } else {
        return "✖";
      }
    },
    checkIsTagClass(tag, tags) {
      if (tags.includes(tag)) {
        return "tagYes";
      } else {
        return "tagNo";
      }
    },
    checkIsNotTag(tag, tags) {
      if (tags.includes(tag)) {
        return "✖";
      } else {
        return "✔";
      }
    },
    checkIsNotTagClass(tag, tags) {
      if (tags.includes(tag)) {
        return "tagNo";
      } else {
        return "tagYesGray";
      }
    },
    getToolboxTagsConfig() {
      toolboxTagsConfig()
        .then((res) => {
          this.tagsConfig = res.data;
          this.checkedTags = this.tagsConfig;
        })
        .catch((err) => {});
    },
    getToolboxList() {
      toolboxList()
        .then((res) => {
          this.toolboxTypes = res.data.toolboxTypes;
        })
        .catch((err) => {});
    },
    changeRate(item) {
      toolboxRate({ id: item.id, rateNum: item.rateNum })
        .then((res) => {
          this.$notify({
            message: "提交评分成功",
            type: "success",
            showClose: false,
            position: "bottom-right",
            duration: 2000,
          });
          this.getToolboxList();
        })
        .catch((err) => {
          this.$notify({
            message: "提交评分失败：" + err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
          this.getToolboxList();
        });
    },
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach((item) => {
        if (item.pageLabel == "toolbox") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped >
.article-wrapper {
  font-size: 14px;
}
.article-tags {
  margin-top: 8px;
}
.article-tags .el-tag {
  height: 26px !important;
  padding: 0 6px !important;
  line-height: 24px !important;
}
.article-tags-tag {
  margin: 0px 2px;
}
@media (min-width: 760px) {
  .article-wrapper {
    padding: 0.5rem 1rem;
    width: 95%;
  }
  .article-name {
    font-size: 1.5rem;
  }
  .article-title {
    font-size: 1rem;
    transition: all 0.3s;
    display: flex;
    align-items: flex-end;
  }
}
@media (max-width: 759px) {
  .article-wrapper {
    padding: 0.75rem 0.75rem 1.875rem;
  }

  .article-name {
    font-size: 1.25rem;
  }
  .article-title {
    font-size: 1rem;
    transition: all 0.3s;
    display: flex;
    align-items: flex-end;
  }
}
.card {
  padding: 0px;
  width: 270px;
}
:deep(.card .el-card__body) {
  padding: 0px !important;
}

.on-hover {
  transition: all 0.6s;
}

.card:hover .on-hover {
  transform: scale(1.05);
}
.article-info {
  font-size: 95%;
  color: #858585;
  line-height: 2;
  margin: 0.375rem 0;
}

.article-info a {
  font-size: 95%;
  color: #858585 !important;
}

.article-content {
  line-height: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.tagYes {
  color: green;
}
.tagNo {
  color: #e93d3d;
}
.tagYesGray {
  color: #294935;
}

.el-divider--horizontal {
  margin: 8px 0;
}
.el-checkbox {
  margin-right: 8px;
  margin-left: 0px !important;
  margin-top: 6px;
}
.tag-checkbox {
  margin: 12px;
  /* border: solid 1px #999; */
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.showClass {
  display: block;
}
.hideClass {
  display: none;
}
.message-tip {
  font-size: 10px;
  font-style: italic;
  color: #aaa;
  margin-bottom: 4px;
  font-style: italic;
  margin-left: 16px;
}
.theme--dark.v-application .article-content {
  color: #aaa;
}
.theme--dark.v-application .article-title {
  color: #aaa;
}
</style>